module.exports = __webpack_public_path__ + "media/images/step_02-8c3dfa26128107e03ca76bc9786e8aae.gif";